var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPregTest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AEBDF2A7-25B5-4B2B-AC74-CC0E20A63AC5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "33.-Part-2---Who-can-use-Hana-UI",
    transform: "translate(-363.000000, -773.000000)",
    strokeWidth: 1.68000005
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(364.000000, 774.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    stroke: "#EE7330",
    points: "34.382749 17.6925245 27.7217888 11.0314443 38.7531492 8.40000025e-05 45.4142294 6.6610442"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    stroke: "#222456",
    points: "31.0703769 23.2918687 22.1224567 14.3439484 26.5781768 9.88798829 35.5262171 18.8360286"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 13.614240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33964007,29.4603969 L2.33952007,29.4603969 C-0.839160025,26.2817168 -0.769800023,21.1070766 2.49300007,18.0146765 L21.4452006,0.0524760016 L31.7475609,10.3548363 L13.7852404,29.3070369 C10.6929603,32.569717 5.51832016,32.639077 2.33964007,29.4603969 Z",
    id: "Stroke-4",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0776286,17.4942725 C18.1419485,20.4300726 14.2460284,21.2939526 12.3760684,19.4239926 C10.5059883,17.5539125 11.3699883,13.6581124 14.3057884,10.7223123 C17.2414685,7.78663223 21.1373886,6.92263221 23.0073487,8.79259226 C24.8773087,10.6626723 24.0134287,14.5584724 21.0776286,17.4942725 Z",
    id: "Stroke-6",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8976886,13.0491124 C20.3048886,13.6419124 19.3436886,13.6419124 18.7508886,13.0491124 C18.1579685,12.4563124 18.1579685,11.4951123 18.7508886,10.9023123 C19.3436886,10.3095123 20.3048886,10.3095123 20.8976886,10.9023123 C21.4904886,11.4951123 21.4904886,12.4563124 20.8976886,13.0491124 Z",
    id: "Stroke-8",
    stroke: "#EE7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8627365,17.0841125 C16.2699365,17.6769125 15.3087365,17.6769125 14.7158164,17.0841125 C14.1230164,16.4913125 14.1230164,15.5301125 14.7158164,14.9371924 C15.3087365,14.3443924 16.2699365,14.3443924 16.8627365,14.9371924 C17.4555365,15.5301125 17.4555365,16.4913125 16.8627365,17.0841125 Z",
    id: "Stroke-10",
    stroke: "#EE7330"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPregTest);
export default __webpack_public_path__ + "static/media/pregTest.e7549ebe.svg";
export { ForwardRef as ReactComponent };